import { useEffect, useState } from "react";

const GAZE_TRACE_KEY = "tdbrowse.showGazeTrace";
const GAZE_TRACE_EVENT = "tdbrowse.showGazeTrace.changed";

const getStoredValue = () => {
  const storedValue = window.localStorage.getItem(GAZE_TRACE_KEY);
  return storedValue === "true";
};

export const useGazeTraceSetting = () => {
  const [showGazeTrace, setShowGazeTrace] = useState(() => getStoredValue());

  useEffect(() => {
    window.localStorage.setItem(GAZE_TRACE_KEY, String(showGazeTrace));

    window.dispatchEvent(
      new CustomEvent(GAZE_TRACE_EVENT, {
        detail: { value: showGazeTrace },
      }),
    );
  }, [showGazeTrace]);

  useEffect(() => {
    const handleStorage = (event) => {
      if (event.key === GAZE_TRACE_KEY) {
        setShowGazeTrace(getStoredValue());
      }
    };

    const handleLocalChange = (event) => {
      setShowGazeTrace(event.detail.value);
    };

    window.addEventListener("storage", handleStorage);
    window.addEventListener(GAZE_TRACE_EVENT, handleLocalChange);

    return () => {
      window.removeEventListener("storage", handleStorage);
      window.removeEventListener(GAZE_TRACE_EVENT, handleLocalChange);
    };
  }, []);

  return [showGazeTrace, setShowGazeTrace];
};
